import type { ModuleSearchResult } from '@/lib/api/search'
import { getOrgPath } from '@/utils/org-paths'

/** Deep-link a global-search ticket result into the ticket split detail. */
export function getTicketSearchPath(
  organizationSlug: string,
  result: Pick<ModuleSearchResult, 'id' | 'identifier'>,
): string {
  const ticketReference = result.identifier?.trim() || result.id
  return getOrgPath(
    organizationSlug,
    `/tickets?ticket=${encodeURIComponent(ticketReference)}`,
  )
}
